module.exports = __webpack_public_path__ + "img/ic_page_dots.5553093e.svg";